export default "__VITE_ASSET__B51C_iRP__"